import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const EmailTemplates = lazy(() =>
  import("@scenes/MessageComposition/Email/EmailTemplates/EmailTemplateLibrary/EmailTemplateList").then(
    (module) => ({
      default: module.EmailTemplateList,
    })
  )
);

export const emailTemplatesNRO: NavigationRoutingObject = {
  Component: EmailTemplates,
  componentFeatureFlippers: ["email_templates_nro_component"],
  section: "templates",
  heading: (t: I18nT<"dashboard-navigation">) => t("email-templates", "Email Templates"),
  pageNameForTracking: () => "Email Templates",
  description: (t: I18nT<"dashboard-navigation">) =>
    t("email-templates-description-nav", "Create and manage email templates"),
  icon: "nav-system-email-templates",
  getDeveloperNavigationAllowed: () => {
    // Always display in side navigation; no-permission view is rendered inside EmailTemplateList
    return true;
  },
  shouldShowTertiaryNavigationCallback: ({ hasPermission }) => {
    return hasPermission("appGroupOrAnyTeamInAppGroup", { permission: "viewEmailTemplates" });
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
};
